<template>
  <el-form 
    :model="editForm"
    :rules="editFormRules"
    ref="editForm"
    label-width="100px" 
    style="margin:20px;width:60%;min-width:600px;">

    <el-form-item 
      label="旧密码"
      >
      <el-input
        v-model="editForm.currentPassword"
        style="width: 300px"
        show-password
        type="text"
        auto-complete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="newPassword">
      <el-input
        v-model="editForm.newPassword"
        style="width: 300px"
        show-password
        auto-complete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input v-model="editForm.confirmPassword" style="width: 300px" show-password auto-complete="off"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button @click="onSubmit" type="primary">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { 
  ChangePassword
} from "../../../api/api";
export default {
  data() {
    const validatePwd = (rule, value, callback) => {
      if (!/^\w{8,16}$/.test(value)) {
        callback(new Error('密码长度8到16位，只能包含字母、数字和下划线'))
      }
      callback()
    }
    return {
      editForm: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      editFormRules: {
        newPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { trigger: ['blur', 'change'], validator: validatePwd, }
        ],
        confirmPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { trigger: ['blur', 'change'], validator: validatePwd, }
        ]
      },
    };
  },
  methods: {
    onSubmit() {
      let that = this;
      that.$refs.editForm.validate((valid) => {
        if (valid) {
          if (that.editForm.newPassword != that.editForm.confirmPassword) {
            return that.$message.error("两次输入新密码不一致!");
          }
          ChangePassword(that.editForm).then((res) => {
            if (res.data.success) {
              that.$message.success('修改成功');
            } else {
              that.$message.error(res.data.error.message)
            }
          });
        }
      });
    },
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
}
.plus-sign {
  line-height: 120px !important;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.markdown-body {
  height: 500px !important;
}
</style>